// import React from 'react'

export const About = () => {
  return (
    <div className="mt-10 text-center text-gray-400">
        <h1 className="text-2xl">About</h1>
        <p>The creation of this app is to share the components you have and you can directly import it to the project.</p>
    </div>
  )
}
